import { render, staticRenderFns } from "./BOrderStatementDetails.vue?vue&type=template&id=21570569&scoped=true"
import script from "./BOrderStatementDetails.vue?vue&type=script&lang=ts"
export * from "./BOrderStatementDetails.vue?vue&type=script&lang=ts"
import style0 from "./BOrderStatementDetails.vue?vue&type=style&index=0&id=21570569&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21570569",
  null
  
)

export default component.exports